export const BreadcrumbData: Array<any> = [
  {
    id: '$home',
    url: '/dashboard',
    label: 'Dashboard',
  },
  {
    id: '$home',
    url: '/domain-management',
    label: 'Domain Management',
  },
  {
    id: '$home',
    url: '/domain-setup',
    label: 'Domain Setup',
  },
  {
    id: '$home',
    url: '/adv-domain-setup',
    label: 'Domain Setup',
  },
  {
    id: '$home',
    url: '/organization-management',
    label: 'Organization Management',
  },
  {
    id: '$home',
    url: '/permission-management',
    label: 'Permission Management',
  },
  {
    id: '$home',
    url: '/role-management',
    label: 'Role Management',
  },
  {
    id: '$home',
    url: '/users-and-groups',
    label: 'User and Groups',
  },
  {
    id: '$home',
    url: '/create-groups',
    label: 'Create Groups',
  },
  {
    id: '$home',
    url: '/create-users',
    label: 'Create Users',
  },
  {
    id: '$home',
    url: '/application-management',
    label: 'Application Management',
  },
  {
    id: '$home',
    url: '/advanced-api-management',
    label: 'Advanced API Management',
  },
  {
    id: '$home',
    url: '/authentication-settings',
    label: 'Authentication Settings',
  },
  {
    id: '$home',
    url: '/admin-domain-management',
    label: 'Domain',
  },
  {
    id: '$account-settings',
    url: '/account-settings',
    label: 'User Account Settings',
  },
  {
    id: '$application-creation',
    url: '/application-creation',
    label: 'Application Creation',
  },
  {
    id: '$entities',
    url: '/entities',
    label: 'Entities',
  },
  {
    id: '$entities',
    url: '/create-entity',
    label: 'Create Entity',
  },
  {
    id: '$mapping-management',
    url: '/mapping-management',
    label: 'Mapping',
  },
  {
    id: '$mapping-management-resources',
    url: '/resources',
    label: 'Mapping Management',
  },
  {
    id: '$create-domain',
    url: '/create-domain',
    label: 'Create Domain',
  },
];
